


























import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
// import { setInterval } from "timers";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";
import HorizontalAlignLeft from "../resources/horizontalAlignLeft.vue";
import HorizontalAlignCenter from "../resources/horizontalAlignCenter.vue";
import HorizontalAlignRight from "../resources/horizontalAlignRight.vue";
import HorizontalAlignEven from "../resources/horizontalAlignEven.vue";
import VerticalAlignTop from "../resources/verticalAlignTop.vue";
import VerticalAlignCenter from "../resources/verticalAlignCenter.vue";
import VerticalAlignBottom from "../resources/verticalAlignBottom.vue";
import VerticalAlignEven from "../resources/verticalAlignEven.vue";

import SelectPattern from "@/views/designEditor/topController/selectPattern/selectPattern.vue"

@Component({
  components: {
    ArrowDown,
    ArrowRight,
    CheckBoxOn,
    HorizontalAlignLeft,
    HorizontalAlignCenter,
    HorizontalAlignRight,
    HorizontalAlignEven,
    VerticalAlignTop,
    VerticalAlignCenter,
    VerticalAlignBottom,
    VerticalAlignEven,
    SelectPattern
  }
})
export default class ImageClipping extends Vue {
  @Prop()
  private layer!: Layer;
  
  private isSelectPatternVisible = false;

  //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
  //こいつはpropsでもらいたい → storeから直接取ってくることになった
  openStatus = {
    opend: true
  };

  imageClippingContentsOpenAnimate = false;
  imageClippingContentsCloseAnimate = false;

  open() {
    if (this.openStatus.opend) {
      this.imageClippingContentsCloseAnimate = true;
      setTimeout(() => {
        this.openStatus.opend = false;
        this.imageClippingContentsOpenAnimate = false;
        this.imageClippingContentsCloseAnimate = false;
      }, 200);
    } else {
      this.openStatus.opend = true;
      this.imageClippingContentsOpenAnimate = true;
      setTimeout(() => {
        this.imageClippingContentsOpenAnimate = false;
      }, 250);
    }
  }
  //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

  private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

  private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    private onSelectPattern(pattern : number, corner : number)
    {
        // 図形選択された
        // クリップ形状変更
        this.$emit("doCommand", "changeLayerClipShape", { layer : this.layer, pattern : pattern, corner : corner });
    }
}
